import { render } from "./AppLayoutAside.vue?vue&type=template&id=37d9fe81"
const script = {}
script.render = render

export default script